export enum ETipoStatusPedido {
    CRIADO = "Criado",
    CONFIRMADO = "Confirmado",
    FINALIZADO = "Finalizado",
    CANCELADO = "Cancelado",
}